import PropTypes from 'prop-types';
import React from 'react';
import EmailSignupStd from './EmailSignupStd/EmailSignupStd';
// import EmailSignupDx from './EmailSignupDx/EmailSignupDx';
import { getLocalStorage } from 'pubweb-smokey/dist/utils/utils';

const EmailSignupContainer = ({
  onCloseEmailPopup,
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  enableShowDx = true,
  pageType = 'homepage',
  modelNumber = null, // Model number is optional depending on page. It is only used for standard email pop-up on home details page form sumbmit event data.
}) => {
  const localStorageDictionary = {
    std: 'emailPopupClosed',
    dx: 'dxPopupClosed',
  };

  // The DX email sign up was disabled 11/13/2023. Leaving the code in case we need to enable a similar DX pop up again.

  // const location = getLocalStorage('chUserLocation');

  // Note: The DX pop up is disabled on Home Details, and Studio.
  const showDx = false; //enableShowDx && (location?.state === 'SC' || location?.state === 'GA');

  // if (showDx && getLocalStorage(localStorageDictionary.dx) !== true) {
  //   return (
  //     <EmailSignupDx
  //       onCloseEmailPopup={onCloseEmailPopup}
  //       localStorageKey={localStorageDictionary.dx}
  //     />
  //   );
  // }

  if (!showDx && getLocalStorage(localStorageDictionary.std) !== true) {
    return (
      <EmailSignupStd
        onCloseEmailPopup={onCloseEmailPopup}
        localStorageKey={localStorageDictionary.std}
        pageType={pageType}
        modelNumber={modelNumber}
      />
    );
  }

  return null;
};

EmailSignupContainer.propTypes = {
  enableShowDx: PropTypes.bool,
  onCloseEmailPopup: PropTypes.func,
  pageType: PropTypes.string,
  modelNumber: PropTypes.string,
};

export default EmailSignupContainer;
